import React from 'react';
import { gql } from '@yi/core';

import { useCurrentUser } from '~/src/common/user';

import { useHasMounted } from './hooks';

type User = gql.typesClient.Query_CurrentUser['CurrentUser'];
interface Props {
  children(s: { isLoggedIn: boolean; currentUser: User }): React.ReactNode;
}

export const CurrentUser: React.FC<Props> = ({ children }) => {
  const { loading, isLoggedIn, currentUser } = useCurrentUser();
  const { hasMounted } = useHasMounted();
  const isFirstRender = !hasMounted;

  if (loading || isFirstRender) {
    return null;
  }

  return <>{children({ isLoggedIn, currentUser })}</>;
};
